export const postWatchServiceBaseUrl = "https://api.postwatch.warnerbros.com";
export const postWatchSharedServiceBaseUrl = "";
export const OKTA_CLIENT_ID = "0oa9rmul222lYsa0T4x7";
export const OKTA_ISSUER_URL = "https://ssobiz.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + "/callback";
export const OKTA_URL = "https://ssobiz.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";
